//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import React from 'react';

interface Props {
  className?: string;
  shouldShowSpinner: boolean;
}

// TODO DEV-38924: Move this into shared area under /app
const InlineLoadingSpinner = ({ className, shouldShowSpinner }: Props) => {
  return (
    <>
      {shouldShowSpinner && (
        <div className={`${className} fa fa-spinner fa-spin`} />
      )}
    </>
  );
};

InlineLoadingSpinner.defaultProps = {
  className: '',
};

export default InlineLoadingSpinner;
